import { css } from 'styled-components';

/**
 * Return feature styles based on a feature and mapping
 */
export const getFeatureStyles = (features: any, featureMap: any) =>
    features && typeof features === 'object'
        ? Object.keys(features).map((feature) => (features[feature] ? featureMap[feature] : undefined))
        : null;

export const VisuallyHidden = css`
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    width: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
`;

export const Field = css`
    border: none;
    padding: 0;
    margin: 0;
`;
